<template>
    <div :disabled="disabled" style="position: relative" v-on:click="insideClicked">
        <div class="time-label" v-on:click="labelClicked">
            <svg version="1.1" width="18" height="18" viewBox="0 0 200 200" style="margin-right: 5px"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g fill="#808080">
                <path d="M55.00,98.00 L75.00,98.00 L75.00,118.00 L55.00,118.00 L55.00,98.00 Z"/>
                <path d="M90.00,98.00 L110.00,98.00 L110.00,118.00 L90.00,118.00 L90.00,98.00 Z"/>
                <path d="M125.00,98.00 L145.00,98.00 L145.00,118.00 L125.00,118.00 L125.00,98.00 Z"/>
                <path d="M55.00,133.00 L75.00,133.00 L75.00,153.00 L55.00,153.00 L55.00,133.00 Z"/>
                <path d="M90.00,133.00 L110.00,133.00 L110.00,153.00 L90.00,153.00 L90.00,133.00 Z"/>
                <path d="M125.00,133.00 L145.00,133.00 L145.00,153.00 L125.00,153.00 L125.00,133.00 Z"/>
                <path d="M40.00,10.00 L70.00,10.00 L70.00,35.00 L40.00,35.00 L40.00,10.00 Z"/>
                <path d="M130.00,10.00 L160.00,10.00 L160.00,35.00 L130.00,35.00 L130.00,10.00 Z"/>
                <path d="M175.45,190.00 C174.04,190.31 79.26,190.47 42.56,190.32 C36.39,190.22 25.46,190.09 25.00,190.00 C23.36,189.64 19.58,187.83 18.45,186.79 C17.30,185.69 15.40,182.12 15.00,180.45 C14.66,178.92 14.46,85.86 14.68,51.00 C14.75,48.09 14.92,40.47 15.00,40.00 C15.30,38.41 16.86,34.38 17.70,33.34 C18.76,32.09 22.13,30.51 24.55,30.00 C27.71,29.39 45.20,29.87 50.00,30.00 C50.00,30.00 150.00,30.00 150.00,30.00 C152.74,29.92 159.70,29.72 163.93,29.59 C166.93,29.54 176.08,29.91 179.30,31.41 C180.90,32.20 182.98,34.62 183.75,36.44 C185.09,39.81 185.24,47.22 185.28,48.68 C185.73,78.18 185.31,178.47 185.00,180.00 C184.64,181.64 182.81,185.43 181.78,186.56 C180.68,187.71 177.12,189.61 175.45,190.00 M30.00,175.00 L30.00,75.00 L170.00,75.00 L170.00,175.00 L30.00,175.00 Z" fill-rule="evenodd"/>
                </g>
            </svg>
            <span>{{ SelectedText }}</span>
        </div>
        <div v-show="CalendarFlag" class="calendar-box" :style="position">
            <Calendar ref="calendar" :value="value" @input="calendarInputed" :min="min" :max="max" />
        </div>
    </div>
</template>

<script>
import Calendar from "./Calendar"
import Util from "../assets/utility"

export default {
    components:{
        Calendar,
    },
    props: {
        format: {
            type: String,
            default: "yyyy/MM/dd"
        },
        position: {
            type: String,
            default: "top: 28px; left: 0;"
        },
        value: {
            type: Date,
            default() { return new Date() },
        },
        min: {
            type: Date,
            default: null,
        },
        max: {
            type: Date,
            default: null,
        },
        disabled: {
            default: false,
        }
    },
    data() {
        return {
            CalendarFlag: false,
            InsideClickFlag: false,
            SelectedText: "",
        }
    },
    mounted() {
        this.SelectedText = Util.formatDate(this.$props.value, this.format) 
        document.addEventListener("click", this.outsideClicked)
    },
    destroyed() {
        document.removeEventListener("click", this.outsideClicked)
    },
    methods: {
        labelClicked : function(){
            this.CalendarFlag = !this.CalendarFlag
        },
        insideClicked: function(){
            this.InsideClickFlag = true
        },
        outsideClicked: function(){
            if(!this.InsideClickFlag)
                this.CalendarFlag = false
            this.InsideClickFlag = false
        },
        calendarInputed: function(event){
            this.SelectedText = Util.formatDate(event, this.format)
            this.outsideClicked()
            this.$emit('input', event)
        },
        setValue: function(d){
            this.$refs["calendar"].setValue(d)
        },
        getValue: function(){
            return this.$refs["calendar"].getValue()
        }
    },
}
</script>

<style scoped>
[disabled]{
    pointer-events: none;
    color: gray;
}
.time-label{
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid gray;
    padding: 1px 2px;
    border-radius: 2px;
    cursor: pointer;
    transition: border-color 200ms ease;
}
.time-label:hover{
    border-color: #76b1cc;
}
.calendar-box{
    z-index: 10;
    position: absolute;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>
